// extracted by mini-css-extract-plugin
export var bodySections = "_8a-8";
export var gray = "_8a-7";
export var green = "_8a-4";
export var iconContainer = "_8a-9";
export var iconWidgetContainer = "_8a-1";
export var phoneIcon = "_8a-2";
export var red = "_8a-5";
export var statusDot = "_8a-3";
export var widgetContainer = "_8a-0";
export var yellow = "_8a-6";